import { ApiCall } from "../../utils/index"

export const getPublicAssetTrackingData = (request) => async() => {
    try {
        const result = await ApiCall.get(`/todo_performance/assetTracking/${request.activity_assignment_id}`);
        request.onSuccess(result.data);
    } catch (error) {
        console.log('error while getting public asset tracking data ---', error)
        request.onError()
    }
}

export const getTodoPerformanceList = (request) => async() => {
    try {
        const result = await ApiCall.get(`/todo_performance/todo_performance_list/${request.activity_assignment_id}`);
        request.onSuccess(result.data);
    } catch (error) {
        console.log('error while getting public asset tracking data ---', error)
        request.onError()
    }
}